'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _require = require('./baseEntity'),
    BaseEntity = _require.BaseEntity;

var _require2 = require('../resource'),
    PublikationsuploadResource = _require2.PublikationsuploadResource;

module.exports.Publikationsupload = function (_BaseEntity) {
  _inherits(Publikationsupload, _BaseEntity);

  _createClass(Publikationsupload, null, [{
    key: '__name__',
    value: function __name__() {
      return 'publikationsupload';
    }
  }]);

  function Publikationsupload(data) {
    _classCallCheck(this, Publikationsupload);

    var _this = _possibleConstructorReturn(this, (Publikationsupload.__proto__ || Object.getPrototypeOf(Publikationsupload)).call(this));

    _this._entityName = 'de.ul.fob.domain.PublikationsUpload';
    _this.optionalComment = null;

    _this.dateiUpload = null;
    _this.organisationseinheit = null;
    _this.publikationsUpload = null;
    _get(Publikationsupload.prototype.__proto__ || Object.getPrototypeOf(Publikationsupload.prototype), 'init', _this).call(_this, data);
    return _this;
  }

  _createClass(Publikationsupload, [{
    key: 'toPostData',
    value: function toPostData() {
      return this.genericJSON({
        fields: ['_id', 'optionalComment'],
        links: ['dateiUpload', 'organisationseinheit', 'publikationsUpload']
      });
    }
  }, {
    key: 'fetchDateiUpload',
    value: function fetchDateiUpload() {
      return _get(Publikationsupload.prototype.__proto__ || Object.getPrototypeOf(Publikationsupload.prototype), 'genericResolve', this).call(this, 'dateiUpload');
    }
  }, {
    key: 'fetchOrganisationseinheit',
    value: function fetchOrganisationseinheit() {
      return _get(Publikationsupload.prototype.__proto__ || Object.getPrototypeOf(Publikationsupload.prototype), 'genericResolve', this).call(this, 'organisationseinheit');
    }
  }, {
    key: 'fetchPublikationsUpload',
    value: function fetchPublikationsUpload() {
      return _get(Publikationsupload.prototype.__proto__ || Object.getPrototypeOf(Publikationsupload.prototype), 'genericResolve', this).call(this, 'publikationsUpload');
    }
  }, {
    key: 'fetchAll',
    value: function fetchAll() {
      return Promise.all([_get(Publikationsupload.prototype.__proto__ || Object.getPrototypeOf(Publikationsupload.prototype), 'genericResolve', this).call(this, 'dateiUpload'), _get(Publikationsupload.prototype.__proto__ || Object.getPrototypeOf(Publikationsupload.prototype), 'genericResolve', this).call(this, 'organisationseinheit'), _get(Publikationsupload.prototype.__proto__ || Object.getPrototypeOf(Publikationsupload.prototype), 'genericResolve', this).call(this, 'publikationsUpload')]);
    }
  }, {
    key: 'fetchResource',
    value: function fetchResource() {
      if (typeof PublikationsuploadResource === 'undefined') {
        return this.fetchAll();
      } else {
        return _get(Publikationsupload.prototype.__proto__ || Object.getPrototypeOf(Publikationsupload.prototype), 'fetchQuery', this).call(this, PublikationsuploadResource);
      }
    }
  }]);

  return Publikationsupload;
}(BaseEntity);


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/entity/publikationsupload.js
// module id = oDOE
// module chunks = 0